"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueuedNotificationPayload = exports.AlarmTriggerPayload = exports.OccurrenceTriggerPayload = exports.Occurrence = exports.OccurrenceName = exports.ConnectionStateTriggerPayload = exports.TelemetryTriggerPayload = exports.RegistryUpdatePayload = exports.CommandPayload = exports.CommandError = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../json"));
exports.NAMESPACE = 'Culligan.Api.V1.PubSub.Device.Schema';
const idDescription = 'Serial number of the device. At least one of deviceId and serialNumber must not be empty.';
exports.CommandError = effect_1.Schema.Struct({
    message: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Error text the device reported',
    }),
    details: effect_1.Schema.optionalWith(Json.Value, { exact: true }).annotations({
        description: 'Error details the device reported',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.CommandError`,
    description: 'Error reported by the device. Read for dispensing.failed.',
});
const commandFields = {
    command: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'Command name, in lower case. The prefix that picks the handler is matched in any letter case, but most handlers then compare the whole command, see the operation description.',
    }),
    protocolVersion: effect_1.Schema.optionalWith(effect_1.Schema.Union(effect_1.Schema.Int.pipe(effect_1.Schema.between(1, 3)), effect_1.Schema.Literal('1', '2', '3')), {
        exact: true,
    }).annotations({
        description: 'Protocol version of the device message, as a number or a numeric string',
    }),
    requestId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Request id, echoed back to the device in the answer',
    }),
    params: effect_1.Schema.optionalWith(Json.Record, { exact: true }).annotations({
        description: 'Command parameters. user.dashboard needs userId; dispensing.* read drinkId, flavourIntensity, waterType, size, userId, containerId, passId, engage, startTime and endTime. A command that needs params and has none fails with 500.',
    }),
    error: effect_1.Schema.optionalWith(exports.CommandError, { exact: true }),
};
/** backend-functions forwards the whole V1 message, so other fields such as schemaVersion come along. */
const messageFields = effect_1.Schema.Record({ key: effect_1.Schema.String, value: Json.Value });
exports.CommandPayload = effect_1.Schema.Union(effect_1.Schema.Struct({
    deviceId: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({ description: idDescription }),
    serialNumber: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Used only when deviceId is empty or missing',
    }),
    ...commandFields,
}, messageFields), effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: idDescription,
    }),
    deviceId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Wins over serialNumber when it is not empty',
    }),
    ...commandFields,
}, messageFields)).annotations({
    identifier: `${exports.NAMESPACE}.CommandPayload`,
    description: 'A command sent by a device, to be handled by the cloud',
});
exports.RegistryUpdatePayload = effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'Serial number of the device to update. The device must exist, a missing or unknown one fails with 500. Not stored as a field.',
    }),
    dealerId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Dealer id, trimmed before it is stored. When set, the owner of the device is also moved to this dealer.',
    }),
}, effect_1.Schema.Record({ key: effect_1.Schema.String, value: Json.Value })).annotations({
    identifier: `${exports.NAMESPACE}.RegistryUpdatePayload`,
    description: 'serialNumber and any fields of the device document to change. id and updatedAt are set by the server and overwrite what is sent.',
});
const serialNumber = (description) => effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({ description });
const model = effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
    description: 'Model code of the device. Used to pick the rules that apply to it.',
});
const tenantId = effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
    description: 'Tenant of the device, used to find tenant-scoped rules. null is a 422.',
});
const unreadTenantId = effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
    description: 'Tenant of the device. Sent by backend-functions, not read here',
});
const before = (description) => effect_1.Schema.optionalWith(Json.Record, { exact: true }).annotations({ description });
exports.TelemetryTriggerPayload = effect_1.Schema.Struct({
    serialNumber: serialNumber('Serial number of the device'),
    model,
    before: before('Datapoints before the change: a flat map of property name to value, state and telemetry merged. Taken as empty when missing.'),
    after: effect_1.Schema.propertySignature(Json.Record).annotations({
        description: 'Datapoints after the change, in the same shape as before. Bit flags are unpacked by the sender.',
    }),
    tenantId,
}).annotations({
    identifier: `${exports.NAMESPACE}.TelemetryTriggerPayload`,
    description: 'A change of the state or telemetry of a device, to run its telemetry rules on',
});
exports.ConnectionStateTriggerPayload = effect_1.Schema.Struct({
    serialNumber: serialNumber('Serial number of the device'),
    model,
    before: before('Status before the change, as { status: { connection } }. The sender leaves it out when the device had no connection state yet.'),
    after: effect_1.Schema.propertySignature(Json.Record).annotations({
        description: 'Status after the change, as { status: { connection } } with online, hub and lastUpdate.',
    }),
    tenantId: unreadTenantId,
}).annotations({
    identifier: `${exports.NAMESPACE}.ConnectionStateTriggerPayload`,
    description: 'A change of the connection state of a device, to run its registry rules on',
});
exports.OccurrenceName = effect_1.Schema.Union(effect_1.Schema.String, effect_1.Schema.Struct({ message: effect_1.Schema.String }, effect_1.Schema.Record({ key: effect_1.Schema.String, value: Json.Value }))).annotations({
    identifier: `${exports.NAMESPACE}.OccurrenceName`,
    description: 'A string, or an object whose message is the name',
});
const occurrenceName = (key) => effect_1.Schema.optionalWith(exports.OccurrenceName, { exact: true }).annotations({
    description: `Name of the occurrence, read from ${key}`,
});
exports.Occurrence = effect_1.Schema.Struct({
    event: occurrenceName('event'),
    alarm: occurrenceName('alarm'),
    error: occurrenceName('error'),
    eventName: occurrenceName('eventName'),
    alarmName: occurrenceName('alarmName'),
    errorName: occurrenceName('errorName'),
    name: occurrenceName('name'),
}, effect_1.Schema.Record({ key: effect_1.Schema.String, value: Json.Value })).annotations({
    identifier: `${exports.NAMESPACE}.Occurrence`,
    description: 'An event, alarm or error of a device. The keys are tried in this order: event, alarm, error, eventName, alarmName, errorName, name. The name is compared with the occurrenceName of each rule.',
});
const occurrence = effect_1.Schema.propertySignature(exports.Occurrence).annotations({
    description: 'What happened on the device. An empty object is let through and matches no rule.',
});
exports.OccurrenceTriggerPayload = effect_1.Schema.Struct({
    serialNumber: serialNumber('Serial number of the device'),
    model,
    occurrence,
    tenantId: unreadTenantId,
}).annotations({
    identifier: `${exports.NAMESPACE}.OccurrenceTriggerPayload`,
    description: 'An event or error of a device, to run its rules on',
});
exports.AlarmTriggerPayload = effect_1.Schema.Struct({
    serialNumber: serialNumber('Serial number of the device'),
    model,
    occurrence,
    tenantId,
}).annotations({
    identifier: `${exports.NAMESPACE}.AlarmTriggerPayload`,
    description: 'An alarm of a device, to run its alarm rules on',
});
exports.QueuedNotificationPayload = effect_1.Schema.Struct({
    serialNumber: serialNumber('Serial number of the device the rule was queued for'),
    ruleId: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'Id of the queued rule',
    }),
    userId: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'Id of the user who owns the rule',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.QueuedNotificationPayload`,
    description: 'The scheduler posts this back when the grace period of a queued rule is over',
});
//# sourceMappingURL=schema.js.map